export default __webpack_public_path__ + "static/media/aline.0515e58b.jpg";